
import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/d8542a2d86413fcab517c86ee3bc4718.jpg')`
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/80 via-slate-900/60 to-purple-900/80"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-8 leading-tight">
            Secure Your<br />
            <span className="text-cyan-400">Digital Freedom</span><br />
            <em className="font-light">With VPN</em>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
            Enterprise-grade VPN protection with military-grade encryption, global server network, and lightning-fast speeds for complete digital privacy.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Button variant="primary" size="lg">
              <i className="ri-shield-check-line mr-2"></i>
              Get Started
            </Button>
            <Button variant="secondary" size="lg">
              <i className="ri-play-circle-line mr-2"></i>
              Learn More
            </Button>
          </div>
        </div>
      </section>

      {/* VPN Service Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">
                OUR SERVICE
              </p>
              <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-8 leading-tight">
                Enterprise-Grade<br />
                <strong className="text-cyan-500">VPN Protection</strong>
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-8">
                QUORUM DOO CACAK delivers <strong>cutting-edge VPN technology</strong> designed for businesses and individuals who demand the highest level of security. Our <strong>military-grade encryption</strong> ensures your data remains private while our <strong>global server network</strong> provides unrestricted access to the internet from anywhere in the world.
              </p>
              <Link to="/vpn-service">
                <Button variant="outline">
                  Explore VPN Service
                  <i className="ri-arrow-right-line ml-2"></i>
                </Button>
              </Link>
            </div>
            
            <div className="relative">
              <div className="bg-gradient-to-br from-cyan-50 to-blue-100 rounded-3xl p-8 shadow-2xl">
                <img 
                  src="https://readdy.ai/api/search-image?query=sophisticated%20network%20security%20diagram%20showing%20encrypted%20VPN%20tunnel%20connections%20across%20global%20servers%2C%20clean%20technical%20illustration%20with%20glowing%20data%20paths%2C%20cybersecurity%20visualization%20with%20shield%20icons%20and%20connection%20nodes&width=600&height=400&seq=vpn_diagram_001&orientation=landscape"
                  alt="VPN Network Security Diagram"
                  className="w-full h-80 object-top rounded-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Highlight Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Military-Grade Encryption */}
            <div className="bg-cyan-50 rounded-3xl p-8 text-center">
              <div className="w-16 h-16 bg-cyan-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Military-Grade Encryption</h3>
              <p className="text-gray-600 leading-relaxed">
                AES-256 encryption protocol protects your data with the same security standards used by governments and military organizations worldwide.
              </p>
            </div>

            {/* Global Server Network */}
            <div className="bg-purple-50 rounded-3xl p-8 text-center">
              <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-global-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Global Server Network</h3>
              <p className="text-gray-600 leading-relaxed">
                Access content from anywhere with our extensive network of high-speed servers strategically located across multiple continents.
              </p>
            </div>

            {/* Lightning Fast Speed */}
            <div className="bg-green-50 rounded-3xl p-8 text-center">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-flashlight-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Lightning Fast Speed</h3>
              <p className="text-gray-600 leading-relaxed">
                Experience blazing-fast internet speeds with optimized protocols that minimize latency while maintaining maximum security.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Advanced Features Grid */}
      <section className="py-20 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-4">
              Why Choose<br />
              <span className="text-cyan-400">QUORUM VPN</span>
            </h2>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* No-Log Policy - Large Card */}
            <div className="lg:row-span-2 bg-gradient-to-b from-gray-800 to-gray-900 rounded-3xl p-10 text-center shadow-2xl border border-cyan-400/20">
              <h3 className="text-3xl font-bold text-white mb-8">No-Log Policy</h3>
              <div className="w-24 h-24 mx-auto mb-8">
                <i className="ri-file-forbid-line text-6xl text-cyan-400"></i>
              </div>
              <p className="text-gray-300 text-lg leading-relaxed">
                We never track, collect, or store your online activities. Your privacy is guaranteed with our strict zero-logging policy, ensuring complete anonymity.
              </p>
            </div>
            
            {/* Kill Switch Protection */}
            <div className="bg-gradient-to-r from-blue-900 to-blue-800 rounded-3xl p-8 relative">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h3 className="text-2xl font-bold text-white mb-2">Kill Switch Protection</h3>
                  <p className="text-blue-200">Automatic disconnection safeguard</p>
                </div>
                <div className="flex items-center space-x-2 bg-green-500 px-3 py-1 rounded-full">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                  <span className="text-white text-sm font-medium">Active</span>
                </div>
              </div>
            </div>
            
            {/* Multi-Device Support */}
            <div className="bg-gradient-to-r from-purple-900 to-pink-800 rounded-3xl p-8">
              <h3 className="text-2xl font-bold text-white mb-6">Multi-Device Support</h3>
              <div className="flex items-center justify-center space-x-6 mb-4">
                <i className="ri-smartphone-line text-3xl text-white"></i>
                <i className="ri-tablet-line text-3xl text-white"></i>
                <i className="ri-computer-line text-3xl text-white"></i>
              </div>
              <p className="text-pink-200">Protect all your devices simultaneously</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-cyan-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
            Ready to Secure Your Digital Life?
          </h2>
          <p className="text-xl text-cyan-100 mb-12 leading-relaxed">
            Join thousands of users who trust QUORUM DOO CACAK for their online privacy and security needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link to="/contact">
              <Button variant="secondary" size="lg">
                <i className="ri-mail-line mr-2"></i>
                Get Started Today
              </Button>
            </Link>
            <Link to="/support">
              <Button variant="outline" size="lg">
                <i className="ri-customer-service-2-line mr-2"></i>
                Contact Support
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
